/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Primarystudyinterest_Study_Greek_Philology21Inputs */

const en__field__enum_primarystudyinterest_study_greek_philology21 = /** @type {(inputs: _Field__Enum_Primarystudyinterest_Study_Greek_Philology21Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Greek Philology`)
};

const de__field__enum_primarystudyinterest_study_greek_philology21 = /** @type {(inputs: _Field__Enum_Primarystudyinterest_Study_Greek_Philology21Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Griechische Philologie`)
};

/**
* | output |
* | --- |
* | "Greek Philology" |
*
* @param {_Field__Enum_Primarystudyinterest_Study_Greek_Philology21Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_primarystudyinterest_study_greek_philology21 = /** @type {((inputs?: _Field__Enum_Primarystudyinterest_Study_Greek_Philology21Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Primarystudyinterest_Study_Greek_Philology21Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_primarystudyinterest_study_greek_philology21(inputs)
	return de__field__enum_primarystudyinterest_study_greek_philology21(inputs)
});
export { _field__enum_primarystudyinterest_study_greek_philology21 as "_field__enum_primaryStudyInterest_STUDY_GREEK_PHILOLOGY" }